var _rect, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndigitized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 8,
    height: 8,
    rx: 1.33333,
    stroke: "#EB4D3D",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L12.0704 4.96481C12.9569 4.52154 14 5.1662 14 6.15738V9.84262C14 10.8338 12.9569 11.4785 12.0704 11.0352L10 10V6Z",
    stroke: "#EB4D3D",
    strokeWidth: 1.33333
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.33334,
    y1: 13.7239,
    x2: 13.7239,
    y2: 1.33341,
    stroke: "#EB4D3D",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndigitized);
export default __webpack_public_path__ + "static/media/Undigitized.7799cdd86dc1b4a4ee234380e245fb2f.svg";
export { ForwardRef as ReactComponent };